export const ACCOUNTS_DISABLED = 'disabled';
export const ACCOUNTS_REQUIRED = 'required';
export const ACCOUNTS_OPTIONAL = 'optional';

export const NAME_NOT_REQUIRED = 'not_required';
export const NAME_LAST_NAME = 'last_name_only';
export const NAME_FULL_NAME = 'full_name';

export const ADDRESS_DISABLED = 'disabled';
export const ADDRESS_FOR_COMPANY_ONLY = 'company_only';
export const ADDRESS_ENABLED = 'enabled';

export const ADDRESS_LINE_2_HIDDEN = 'hidden';
export const ADDRESS_LINE_2_OPTIONAL = 'optional';
export const ADDRESS_LINE_2_REQUIRED = 'required';

export const PHONE_NUMBER_HIDDEN = 'hidden';
export const PHONE_NUMBER_OPTIONAL = 'optional';
export const PHONE_NUMBER_REQUIRED = 'required';